import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd402d5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-bar page-default page-media" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-search" }, null, -1))
const _hoisted_4 = ["placeholder", "onKeydown"]
const _hoisted_5 = {
  key: 0,
  class: "right"
}
const _hoisted_6 = { class: "option" }
const _hoisted_7 = { class: "option" }
const _hoisted_8 = { class: "option" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon down i-gengduo" }, null, -1))
const _hoisted_10 = { class: "option" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon down i-gengduo" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "drop"
}
const _hoisted_13 = ["onMousedown"]
const _hoisted_14 = {
  key: 0,
  class: "gou icon i-duigou"
}
const _hoisted_15 = { class: "label" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "label" }

import backMusic, { State as MusicState } from '@/store/backMusic';
import bible, { State } from '@/store/bible/detail';
import search, { State as SearchState } from '@/store/bible/search';
import { computed, onMounted, reactive, watch, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { showBibleVersionSetting } from '@/store/index'
import i18, { State as I18State } from '@/store/i18';
import chajing from '@/api/chajingApi'

interface BookItem {
    sid: number,
    title: string,
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].bible)

const data = computed<State>(() => store.state[bible.name])
const searchData = computed<SearchState>(() => store.state[search.name])
const musicData = computed<MusicState>(() => store.state[backMusic.name])
const biblePlaying = computed(() => musicData.value.bible && musicData.value.list.length > 0)
const state = reactive({
    search: '',
    settingVisible: false,
    bookVisible: false,
})
const books = ref<BookItem[]>([])
const fonts = [14, 18, 22, 26, 30, 34]
const curr = computed(() => route.name)

onMounted(() => {
    state.search = searchData.value.search
})

watch(() => searchData.value.search, () => {
    state.search = searchData.value.search
})

function doSearch() {
    if (state.search) {
        router.push({
            name: 'bible-search',
            params: {
                search: state.search,
                lang: searchData.value.lang,
                type: searchData.value.type,
                page: 0
            }
        })
    }
}

function onShowLangs() {
    showBibleVersionSetting(store)
}

async function onShowBooks() {
    books.value = await chajing.getBooks(data.value.volume + 1, data.value.chapter + 1)
    state.bookVisible = true
    document.onmousedown = function () {
        document.onmousedown = null
        state.bookVisible = false
    }
}

function onBook(item: BookItem) {
    bible.setBook(store, item.sid, item.title)
    window.scrollTo({ left: 0, top: 0, behavior: 'auto' })
}

function onPlayAudio() {
    if (biblePlaying.value) {
        backMusic.shutdown(store)
    } else {
        backMusic.playBible(store, data.value.volume, data.value.chapter, data.value.lang)
    }
}

function onShowSetting() {
    state.settingVisible = true
    document.onmousedown = function () {
        document.onmousedown = null
        state.settingVisible = false
    }
}

function onFont(i: number) {
    data.value.font = i
    window.localStorage.setItem('bfont', i + '')
}

function onColor(i: number) {
    store.commit('bible-detail/setColor', i)
    if (i == 4) {
        store.commit('switchDarkMode', 'true')
    } else {
        store.commit('switchDarkMode', 'false')
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search) = $event)),
        placeholder: _unref(lang).search_placeholder,
        onKeydown: _withKeys(doSearch, ["enter"])
      }, null, 40, _hoisted_4), [
        [
          _vModelText,
          _unref(state).search,
          void 0,
          { trim: true }
        ]
      ]),
      _createElementVNode("a", {
        class: "search-btn",
        onClick: doSearch
      }, _toDisplayString(_unref(lang).search), 1)
    ]),
    (_unref(curr) == 'bible-detail')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/bibles",
              class: "value icon i-home",
              style: {"font-size":"26px"}
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              class: _normalizeClass(["value icon i-a-zu581", { on: _unref(biblePlaying) }]),
              onClick: onPlayAudio
            }, null, 2)
          ]),
          _createElementVNode("div", {
            class: "option",
            onClick: onShowSetting
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["value icon i-a-Iconawesome-font", { on: _unref(state).settingVisible }])
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              class: "value",
              onClick: onShowLangs
            }, [
              _createTextVNode(_toDisplayString(_unref(data).langLabel) + " ", 1),
              _hoisted_9
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", {
              class: "value",
              onClick: onShowBooks
            }, [
              _createTextVNode(_toDisplayString(_unref(lang).book), 1),
              _hoisted_11
            ]),
            (_unref(state).bookVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(books.value, (item, i) => {
                    return (_openBlock(), _createElementBlock("a", {
                      class: _normalizeClass({ on: _unref(data).bookSid == item.sid }),
                      onMousedown: ($event: any) => (onBook(item))
                    }, [
                      _createTextVNode(_toDisplayString(item.title) + " ", 1),
                      (_unref(data).bookSid == item.sid)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_14))
                        : _createCommentVNode("", true)
                    ], 42, _hoisted_13))
                  }), 256))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(state).settingVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "setting",
          onMousedown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(lang).fontsize), 1),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fonts, (n) => {
              return _createElementVNode("a", {
                class: _normalizeClass(["fo", { on: _unref(data).font == n }]),
                style: _normalizeStyle({ fontSize: n + 'px' }),
                onClick: ($event: any) => (onFont(n))
              }, _toDisplayString(n), 15, _hoisted_16)
            }), 64))
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(lang).theme), 1),
            _createElementVNode("a", {
              class: _normalizeClass(["co c4", { on: _unref(data).color == 4 }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onColor(4)))
            }, null, 2),
            _createElementVNode("a", {
              class: _normalizeClass(["co c0", { on: _unref(data).color == 0 }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (onColor(0)))
            }, null, 2),
            _createElementVNode("a", {
              class: _normalizeClass(["co c1", { on: _unref(data).color == 1 }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (onColor(1)))
            }, null, 2),
            _createElementVNode("a", {
              class: _normalizeClass(["co c2", { on: _unref(data).color == 2 }]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (onColor(2)))
            }, null, 2),
            _createElementVNode("a", {
              class: _normalizeClass(["co c3", { on: _unref(data).color == 3 }]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (onColor(3)))
            }, null, 2)
          ])
        ], 32))
      : _createCommentVNode("", true)
  ]))
}
}

})